import { IDatabaseItem } from "../interfaces";

export const TOOLS_ITEMS: Array<IDatabaseItem> = [{
	title: "TRONIC® Univerzální nabíječka baterií TAL 1000 A2",
	price: 599,
	toolsProps: {
		link: "https://www.lidl.cz/p/tronic-univerzalni-nabijecka-baterii-tal-1000-a2/p100367301",
		type: "nabijecka",
	},
	images: [{
		src: "nabijecka-baterii.webp",
		large: "nabijecka-baterii-large.webp",
	}],
}, {
	title: "PARKSIDE® Aku úhlová bruska PWSA 12 B1 – bez akumulátoru a nabíječky",
	price: 449,
	toolsProps: {
		link: "https://www.lidl.cz/p/parkside-aku-uhlova-bruska-pwsa-12-b1-bez-akumulatoru-a-nabijecky/p100346938",
		type: "aku",
		akuType: "parkside-x-12v-team",
	},
	images: [{
		src: "uhlova-bruska.webp",
		large: "uhlova-bruska-large.webp",
	}],
}, {
	title: "PARKSIDE PERFORMANCE® Akumulátor 12 V PAPK 12 2.5 A1",
	price: 399,
	toolsProps: {
		link: "https://www.lidl.cz/p/parkside-performance-akumulator-12-v-papk-12-2-5-a1/p100379111",
		type: "aku-baterie",
		amperHours: 2.5,
		akuType: "parkside-x-12v-team",
	},
	images: [{
		src: "baterie-2.5ah.webp",
		large: "baterie-2.5ah-large.webp",
	}],
}, {
	title: "PARKSIDE® Akumulátor 4 Ah PAP 20 B3",
	price: 899,
	toolsProps: {
		link: "https://www.lidl.cz/p/parkside-akumulator-4-ah-pap-20-b3/p100370678",
		type: "aku-baterie",
		amperHours: 4,
		akuType: "parkside-x-20v-team",
	},
	images: [{
		src: "baterie-4ah.webp",
		large: "baterie-4ah-large.webp",
	}],
}, {
	title: "PARKSIDE® Rychlonabíječka PLG 20 C3",
	price: 399,
	toolsProps: {
		link: "https://www.lidl.cz/p/parkside-rychlonabijecka-plg-20-c3/p100369261",
		type: "nabijecka",
		akuType: "parkside-x-20v-team",
	},
	images: [{
		src: "nabijecka-20v.webp",
		large: "nabijecka-20v-large.webp",
	}],
}, {
	title: "PARKSIDE® Vrtací a sekací kladivo PBH 800 A1",
	price: 1299,
	toolsProps: {
		link: "https://www.lidl.cz/p/parkside-vrtaci-a-sekaci-kladivo-pbh-800-a1/p100359478",
		type: "vrtacka",
		watts: 800,
		knock: true,
	},
	images: [{
		src: "vrtaci-sekaci-kladivo.webp",
		large: "vrtaci-sekaci-kladivo-large.webp",
	}],
}, {
	title: "Narex EVP 13 E-2H3 příklepová vrtačka",
	price: 0,
	toolsProps: {
		link: "https://www.lidl.cz/p/parkside-vrtaci-a-sekaci-kladivo-pbh-800-a1/p100359478",
		type: "vrtacka",
		watts: 650,
		knock: true,
		maxNm: 29,
	},
	images: [{
		src: "narex-evp-13-e2h3.webp",
		large: "narex-evp-13-e2h3-large.webp",
	}],
}, {
	title: "Bosch PST 650 přímočará pila",
	price: 1200,
	desc: "Hornbach",
	toolsProps: {
		link: "https://www.datart.cz/pila-kmitaci-bosch-pst-650-compact.html",
		type: "primocara-pila",
		watts: 500,
	},
	images: [{
		src: "bosch-pst-650.webp",
		large: "bosch-pst-650-large.webp",
	}],
}, {
	title: "PARKSIDE® Akumulátor 2 Ah PAPK 12 A3",
	price: 349,
	desc: "2ks",
	toolsProps: {
		link: "https://www.lidl.cz/p/parkside-akumulator-2-ah-papk-12-a4/p100362854",
		type: "aku-baterie",
		amperHours: 2,
		akuType: "parkside-x-12v-team",
	},
	images: [{
		src: "baterie-2ah.webp",
		large: "baterie-2ah-large.webp",
	}],
}, {
	title: "PARKSIDE® Aku ruční svítilna",
	price: 349,
	toolsProps: {
		link: "",
		type: "svitilna",
	},
	images: [{
		src: "svitilna.webp",
		large: "svitilna-large.webp",
	}],
}, {
	title: "PARKSIDE® Digitální pájecí stanice PLSD 48 B2",
	price: 599,
	toolsProps: {
		link: "https://www.lidl.cz/p/parkside-digitalni-pajeci-stanice-plsd-48-b2/p100354944",
		type: "pajeci-stanice",
	},
	images: [{
		src: "pajeci-stanice.webp",
		large: "pajeci-stanice-large.webp",
	}],
}, {
	title: "PARKSIDE® Aku multifunkční nářadí PAMFW 12 D4 – bez akumulátoru a nabíječky",
	price: 799,
	toolsProps: {
		link: "https://www.lidl.cz/p/parkside-aku-multifunkcni-naradi-pamfw-12-d4-bez-akumulatoru-a-nabijecky/p100346904",
		type: "aku-vibracni-bruska",
		akuType: "parkside-x-12v-team",
	},
	images: [{
		src: "multifunkcni-zarizeni.webp",
		large: "multifunkcni-zarizeni-large.webp",
	}],
}, {
	title: "Aku vrtací šroubovák PBSA 12 D4, 2 Ah",
	price: 699,
	toolsProps: {
		link: "https://www.lidl.cz/p/parkside-aku-vrtaci-sroubovak-pbsa-12-e4-bez-akumulatoru-a-nabijecky/p100381091",
		type: "aku-vrtacka",
		akuType: "parkside-x-12v-team",
		maxNm: 28,
	},
	images: [{
		src: "vrtacka-mensi.webp",
		large: "vrtacka-mensi-large.webp",
	}],
}, {
	title: "PARKSIDE® Nabíječka PLGK 12 A3",
	price: 199,
	toolsProps: {
		link: "https://www.lidl.cz/p/parkside-nabijecka-plgk-12-a3/p100368446",
		type: "nabijecka",
		akuType: "parkside-x-12v-team",
	},
	images: [{
		src: "nabijecka-12v.webp",
		large: "nabijecka-12v-large.webp",
	}],
}, {
	title: "ULTIMATE SPEED® Nabíječka autobaterií ULGD 10 A1",
	price: 999,
	toolsProps: {
		link: "https://www.lidl.cz/p/ultimate-speed-nabijecka-autobaterii-ulgd-10-a1/p100368104",
		type: "nabijecka",
	},
	images: [{
		src: "nabijecka-baterii.webp",
		large: "nabijecka-baterii-large.webp",
	}],
}, {
	title: "DeWALT DCD796D2",
	price: 0,
	toolsProps: {
		link: "https://www.naradi-dewalt.cz/aku-priklepove-vrtacky/aku-bezuhlikova-vrtacka-s-priklepem-18v-xr-li-ion-2x2-0ah-dewalt-dcd796d2-290904",
		type: "aku-vrtacka",
		akuType: "dewalt-18v",
		maxNm: 70,
		knock: true,
		brushLess: true,
	},
	images: [{
		src: "DeWALT-DCD796D2.webp",
		large: "DeWALT-DCD796D2-large.webp",
	}],
}, {
	title: "DeWALT 4 ah",
	price: 0,
	toolsProps: {
		link: "",
		type: "aku-baterie",
		amperHours: 4,
		akuType: "dewalt-18v",
	},
	images: [{
		src: "DeWALT-4-ah.webp",
		large: "DeWALT-4-ah-large.webp",
	}],
}, {
	title: "DeWALT 2 ah",
	price: 0,
	desc: "2ks",
	toolsProps: {
		link: "",
		type: "aku-baterie",
		amperHours: 2,
		akuType: "dewalt-18v",
	},
	images: [{
		src: "DeWALT-2-ah.webp",
		large: "DeWALT-2-ah-large.webp",
	}],
}, {
	title: "DeWALT nabíječka",
	price: 0,
	toolsProps: {
		link: "",
		type: "nabijecka",
		akuType: "dewalt-18v",
	},
	images: [{
		src: "DeWALT-DCD796D2.webp",
		large: "DeWALT-DCD796D2-large.webp",
	}],
}, {
	title: "ULTIMATE SPEED® Startovací zdroj s powerbankou UMAP 12000 C3",
	price: 1199,
	toolsProps: {
		link: "https://www.lidl.cz/p/ultimate-speed-startovaci-zdroj-s-powerbankou-umap-12000-c3/p100367517",
		type: "nabijecka",
	},
	images: [{
		src: "nabijecka-auto.webp",
		large: "nabijecka-auto-large.webp",
	}],
}];
